var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pa-0"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_vm._v(_vm._s((_vm.value + " " + _vm.symbol)))])]}}])},[_c('span',[_vm._v(_vm._s((_vm.value + " " + _vm.name)))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }